'use client'

import type { ReusableStory, SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { StoryblokComponent } from '@storyblok/react'

export type ReusableBlockReferenceProps = SbBaseBlockProps<{
  reference: Omit<ReusableStory, 'content'> & Partial<Pick<ReusableStory, 'content'>>
}>

export const ReusableBlockReference = ({ blok, nested }: ReusableBlockReferenceProps) => {
  return (
    <>
      {blok.reference.content?.body.map((nestedBlock) => (
        <StoryblokComponent blok={nestedBlock} key={nestedBlock._uid} nested={nested} />
      ))}
    </>
  )
}

ReusableBlockReference.blockName = 'reusableBlockReference'
